import qs from "qs";
import endpoints from "@irati/payments/endpoints";
import { getDomain } from "@irati/utils/links";
import authentication from "@irati/auth";
export function getAdyenClassicCallbackUrlForRedirect(deal, saga) {
    var domain = getDomain(authentication.userTenant().subdomain);
    var query = qs.stringify({
        redirectTo: domain + "/perks/info/" + deal.urlSlug + "/payment-redirect/" + saga.uuid
    });
    return endpoints.adyenRedirectCallbackUrl() + "?" + query;
}
export function getZipCallbackUrlForRedirect(deal, saga) {
    var domain = getDomain(authentication.business().subdomain);
    var query = qs.stringify({
        redirectTo: domain + "/perks/info/" + deal.urlSlug + "/payment-redirect/" + saga.uuid
    });
    return endpoints.zipRedirectCallbackUrl() + "?" + query;
}
